import { Body_add_your_food_api_v1_meals_your_food_post } from "@/clients/models/Body_add_your_food_api_v1_meals_your_food_post";
import { BaseModal } from "@/components/modal/base-modal";
import { TextButton } from "@/components/ui/buttons";
import { FilledButton } from "@/components/ui/buttons/FilledButton";
import { useViewportHeight } from "@/hooks/utils/use-viewport-height";
import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { memo } from "react";

interface SaveMealAsModalProps {
  isOpen: boolean;
  onDismiss: () => void;
  disabled?: boolean;
  onSelectMealTime: (mealTime: Body_add_your_food_api_v1_meals_your_food_post.meal_time) => void;
}

const mealTimeOptions = [
  {
    label: "Breakfast",
    value: Body_add_your_food_api_v1_meals_your_food_post.meal_time.BREAKFAST,
  },
  {
    label: "Lunch",
    value: Body_add_your_food_api_v1_meals_your_food_post.meal_time.LUNCH,
  },
  {
    label: "Dinner",
    value: Body_add_your_food_api_v1_meals_your_food_post.meal_time.DINNER,
  },
  {
    label: "Snack",
    value: Body_add_your_food_api_v1_meals_your_food_post.meal_time.SNACK,
  },
];

export const SaveMealAsModal = memo(function SaveMealAsModal({
  isOpen,
  onDismiss,
  disabled,
  onSelectMealTime,
}: SaveMealAsModalProps) {
  const viewportHeight = useViewportHeight();

  const handleSelectMealTime = (
    mealTime: Body_add_your_food_api_v1_meals_your_food_post.meal_time,
  ) => {
    onSelectMealTime(mealTime);
  };

  return (
    <BaseModal
      isOpen={isOpen}
      onDismiss={onDismiss}
      backdropDismiss={true}
      initialBreakpoint={393 / viewportHeight}
      breakpoints={[0, 393 / viewportHeight, 0.9]}
    >
      <div className="safe-area-bottom flex flex-col gap-6 px-8 pt-8 pb-8">
        <h2 className={cn(textVariants.title2, "text-center")}>Save meal as...</h2>

        <div className="flex flex-col gap-2">
          {mealTimeOptions.map((option) => (
            <FilledButton
              key={option.value}
              color="black"
              textCase="normal"
              disabled={disabled}
              onClick={() => handleSelectMealTime(option.value)}
            >
              {option.label}
            </FilledButton>
          ))}

          <TextButton color="black" onClick={onDismiss}>
            Cancel
          </TextButton>
        </div>
      </div>
    </BaseModal>
  );
});
